import { useCallback } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { BACKEND_APIS } from "@constants"
import {
	autoEuropeSeasonSetsIsSubmitting,
	clearAutoEuropeSeasonSetsSignals,
} from "Pages/AutoEuropeTool/SeasonSets/@signals"

const SEASON_SETS_API = `${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/season-sets`

const transformData = data => ({
	...(data.id ? { id: data.id } : {}),
	name: data.name,
	seasonRules: data.seasonRules ?? { dateRanges: [], followingDays: [], nextSaturday: [], finalSeason: false },
})

export default function useAutoEuropeSeasonSetsFormSubmit({ getTableData }) {
	const { showToast } = useToast()

	const onSubmit = useCallback(data => {
		autoEuropeSeasonSetsIsSubmitting.value = true
		const isEditing = !!data.id

		postSubmit(`${SEASON_SETS_API}/${isEditing ? 'edit' : 'create'}`, transformData(data))
			.then(() => {
				autoEuropeSeasonSetsIsSubmitting.value = false
				getTableData()
				clearAutoEuropeSeasonSetsSignals()
				showToast.success(isEditing ? "Season set updated" : "Season set created")
			})
			.catch(() => {
				autoEuropeSeasonSetsIsSubmitting.value = false
				showToast.error("Error saving season set")
			})
	}, [getTableData])

	return { onSubmit }
}
